<template lang="pug">
    tr( :class="color" )
        th( v-if='checkable' )
            v-checkbox( :input-value='all' :indeterminate="indeterminate" primary hide-details @click.stop="toggleAll" )
        th( :key='index' :class='{ header, index, order, whiteSpace } | classSortable' v-for='( header, index ) in headers'  @click='submitSort( header, index )' )
            v-icon( small v-if='header.sortable' ) arrow_upward
            template
                //( v-if="headers.length > index + 1 || !selectableColumns || noActions" )
                span {{ header.text }}
            //template( v-else )
                v-menu( :close-on-content-click="false" offset-x )
                    template( slot="activator" class="justify-content" )
                        v-btn( block dark flat ) {{ header.text }}
                            v-icon.ml-1 more_vert
                    v-list.secondary.darken-2( dark dense )
                        v-subheader Columnas
                        template( v-for="header in headers" )
                            v-list-tile( @click="headers.active = !headers.active" )
                                v-list-tile-action 
                                    v-checkbox( color="white" dark v-model="headers.active" )
                                v-list-tile-content
                                    v-list-tile-title.text-capitalize {{ header.text }}
</template>

<script>
    export default {
        data () {
            return {
                order: {
                    desc: true,
                    index: 0,
                }
            }
        },
        filters: {

            /**
             * 
             */
            classSortable ({ header, index, order, whiteSpace }) {
                return [
                    'column',
                    header.sortable ? 'sortable' : '',
                    order.desc ? 'desc' : 'asc',
                    index === order.index ? 'active' : '',
                    header.align ? 'text-xs-' + header.align : 'text-xs-left',
                    "white-space-" + whiteSpace
                ]
            },
        },
        methods: {

            /**
             * 
             */
            submitSort ( header, index ){
                if ( header.sortable ) {
                    this.order.desc     = !this.order.desc
                    this.order.index    = index                    
                }
            },

            /**
             * 
             */
            toggleAll () {
                this.$emit( 'toggleAll' )
            },

            /**
             * 
             */
            toggleHeader ( index ) {

            }
        },
        props: {

            /**
             * 
             */
            all: [ Boolean, Number ],

            /**
             * 
             */
            selectableColumns: {
                type: Boolean,
                default: false
            },

            /**
             * 
             */
            checkable: Boolean,

            /**
             * 
             */
            color: {
                type: String,
                default: "primary",
            },

            /**
             * 
             */
            headers: Array,

            /**
             * 
             */
            indeterminate: Boolean,

            /**
             * 
             */
            noActions: Boolean,

            /**
             * 
             */
            whiteSpace: {
                type: String,
                default: "nowrap",
            }
        },
        watch: {

            /**
             * 
             */
            'order.desc' () {
                this.$emit( 'input', this.order )
            },

            /**
             * 
             */
            'order.index' () {
                this.$emit( 'input', this.order )
            },
        },
    }
</script>

<style>
    table.v-table thead th.white-space-nowrap {
        white-space: nowrap;
    }

    table.v-table thead th.white-space-normal {
        white-space: normal;
    }
</style>
